import { ApplicationConstants } from './constants';
import configuration from '../../configuration.json';
import { ApplicationState } from './types'; // or wherever your interface is
import { ApplicationAction } from './types'; // if actions are separated

const initialState: ApplicationState = { ...configuration,showHeader:true };

export function application(
  state: ApplicationState = initialState,
  action: ApplicationAction
): ApplicationState {
  switch (action.type) {
    case ApplicationConstants.ADD_APPLICATION_KEY:
    case ApplicationConstants.UPDATE_APPLICATION_KEY:
      return {
        ...state,
        ...action.response,
      };
    default:
      return state;
  }
}
